import { getCookie } from 'cookies-next'

// Snapchat Click ID (sccid) - used for attribution tracking
// Snapchat appends &ScCid= (mixed case) to ad URLs
export function getSccid() {
  if (typeof window !== 'undefined') {
    const searchParams = new URLSearchParams(window.location.search)
    const clickId = searchParams.get('ScCid') || searchParams.get('sccid')
    if (clickId) return clickId
  }
  return getCookie('sccid') || null
}

// Snapchat First-Party Cookie (_scid) - used for CAPI (Conversion API) matching
// Also known as sc_cookie1 or uuid_c1 in Snapchat's API
export function getScCookie1() {
  return getCookie('_scid') || null
}
